<template>
  <div id="nav">
    <div class="nav-left">
    <router-link to="/" id="homelogo">Charg<i class="fas fa-plug"></i>d</router-link>
    </div>
    <div class="nav-right">
    <span v-if="$store.getters.currentUser">
      <span id="logout" @click="Logout"><i class="fas fa-sign-out"></i> Log out</span>
      <label id="username">({{ $store.getters.currentUser.email }})</label>
    </span>
    <span v-else>
      <router-link to="/signup">Create Account</router-link> |
      <router-link to="/login">Log in</router-link>
    </span>
    </div>
  </div>
</template>

<script>
import { getAuth, signOut } from "firebase/auth"
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Welcome from '../views/Welcome.vue'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    const Logout = () => {
      const auth = getAuth()  

      signOut(auth).then(() => {
        // Sign-out successful, update state store and update routes to 
        // block signed-out users from accessing the application.
        store.dispatch('setCurrentUser', null)
        router.addRoute({ path: '/', name: 'Home', component: Welcome })
        router.replace('/')
      }).catch((error) => {
        // An error happened during logout.
        const errorCode = error.code
        const errorMessage = error.message
        alert(errorCode, errorMessage)
      })
    }

    return {
      Logout
    }
  }
}
</script>

<style scoped>
#nav {
  display: flex;
  position: fixed;
  top:0;
  width: 100%;
  /* overflow: auto; */
  height: auto;
  /* flex-direction: row; */
  /* flex-wrap: nowrap; */
  justify-content: space-between;
  margin: 1em;
}

.nav-right {
  margin-left: auto;
  margin-right: 2em;
  margin-top: 4px;
}

#nav a, #logout {
  font-weight: bold;
  color: #1ba098;
  text-decoration: none;
  padding: 10px 4px;
  border-radius: 4px;
}

/* #nav a.router-link-exact-active,  */
#nav a:hover, #logout:hover {
  color: #deb992;
  cursor: pointer;
}

#username {
  color: #deb992;
  display: inline;
}

#homelogo {
  font-size: 26px;
  font-weight: 600;
}

/* for small screens */
@media only screen and (max-width: 600px) {
  #username {
    display: none;
  }
  #homelogo {
    font-size: 22px;
  }
}
</style>